import { Navigate } from "react-router-dom";
import routesConstants from "routes/routesConstants";

const RedirectToHome = () => {
  return <Navigate to={routesConstants.DASHBOARD} replace />;
};
export default RedirectToHome;
